var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{staticClass:"c-social-icon",attrs:{"href":_vm.link,"target":"_blank","aria-label":_vm.ariaLabelLink}},[(_vm.iconName)?_c(_vm.iconName,{tag:"component",staticClass:"c-social-icon__svg"}):_vm._t("iconSlot")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }